import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Snackbar as MuiSnackbar, Alert} from '@mui/material';
import {
  selectIsSnackbarOpen,
  selectSnackbarMessage,
  selectSnackbarSeverity,
  setIsSnackbarOpen
} from './slice';
import {useCallback} from 'react';

export const Snackbar = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectIsSnackbarOpen);
  const severity = useSelector(selectSnackbarSeverity);
  const message = useSelector(selectSnackbarMessage);

  const handleClose = useCallback(() => {
    dispatch(setIsSnackbarOpen(false));
  }, [dispatch]);

  return (
    <MuiSnackbar
      open={isOpen}
      autoHideDuration={5000}
      onClose={handleClose}
      anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}>
      <Alert onClose={handleClose} severity={severity} sx={{width: '100%'}}>
        {message}
      </Alert>
    </MuiSnackbar>
  );
};

export default Snackbar;
